import { useCallback, useRef, useState } from "react";
import { AttachmentIcon } from "@chakra-ui/icons";
import {
  getAntiForgeryToken,
  uploadDataImportFile,
} from "../../clients/BackOfficeApi";
import { Box, FormControl, FormLabel, Heading, Text } from "@chakra-ui/react";
import { FileInput } from "../../components/FileInput";
import { ImportRequestTable } from "../../components/ImportContent/ImportRequestTable";

export function ImportPage() {
  const [errorMessage] = useState<string>();
  const [componentRefreshToken, setComponentRefreshToken] = useState<symbol>();

  const ref = useRef<HTMLInputElement>(null);

  const importFile = useCallback(
    (file: File | undefined) => {
      if (!file) return;

      getAntiForgeryToken({ credentials: "include", throwOnError: true }).then(
        ({ data: xsrfToken }) => uploadDataImportFile({
          body: { file },
          headers: {
            "X-XSRF-TOKEN": xsrfToken,
          },
          credentials: "include",
          throwOnError: true,
        }).finally(() => setComponentRefreshToken(Symbol("ImportRequestTable"))
        ),
      );
    },
    [],
  );

  return (
    <>
      <Heading as="h1" mb="4">
        Data importeren
      </Heading>
      <FormControl mb={4}>
        <FormLabel htmlFor="upload-data-import-file" mt={4}>
          Bestand selecteren
        </FormLabel>
        <FileInput
          ref={ref}
          input={{
            accept: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
            id: "upload-data-import-file",
            name: "upload-data-import-file",
          }}
          noConfirm
          onChange={(files) => importFile(files[0])}
        >
          <AttachmentIcon mr={2} position="relative" /> Selecteer bestand (.xlsx)
        </FileInput>
      </FormControl>
      {errorMessage && <Text color="red.500">{errorMessage}</Text>}
      <ImportRequestTable componentRefreshToken={componentRefreshToken} />
    </>
  );
}
